module.exports = __webpack_public_path__ + "static/sailRankshome-df3af00f2b9c8ad6447513f4e17dbed7.png";